'use strict';

var cov_2ab4oeddii = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/createProjectModal/createProjectModal.js',
        hash = 'b3b2dd0118be78a3bcafff6a1bcea217a3f17d0b',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/createProjectModal/createProjectModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 35,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 63
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 22
                },
                end: {
                    line: 10,
                    column: 26
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 15
                }
            },
            '5': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 51
                }
            },
            '6': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 27,
                    column: 10
                }
            },
            '7': {
                start: {
                    line: 26,
                    column: 12
                },
                end: {
                    line: 26,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 10
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 14
                }
            },
            '10': {
                start: {
                    line: 31,
                    column: 16
                },
                end: {
                    line: 31,
                    column: 40
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 35,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewProjectModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 48
                    },
                    end: {
                        line: 19,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 23
                    },
                    end: {
                        line: 11,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 35
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: 'CreateProjectModalController',
                decl: {
                    start: {
                        line: 22,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 77
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 22
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 25,
                        column: 29
                    },
                    end: {
                        line: 25,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 41
                    },
                    end: {
                        line: 27,
                        column: 9
                    }
                },
                line: 25
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 29,
                        column: 31
                    },
                    end: {
                        line: 29,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 43
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 29
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 30,
                        column: 44
                    },
                    end: {
                        line: 30,
                        column: 45
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 63
                    },
                    end: {
                        line: 32,
                        column: 13
                    }
                },
                line: 30
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2ab4oeddii.s[0]++;
(function () {
    'use strict';

    cov_2ab4oeddii.f[0]++;
    cov_2ab4oeddii.s[1]++;
    angular.module('app').service('NewProjectModalService', NewProjectModalService);

    /* @ngInject */
    function NewProjectModalService($mdDialog) {
        cov_2ab4oeddii.f[1]++;

        var Service = (cov_2ab4oeddii.s[2]++, this);
        cov_2ab4oeddii.s[3]++;
        this.display = function () {
            cov_2ab4oeddii.f[2]++;
            cov_2ab4oeddii.s[4]++;

            return $mdDialog.show({
                templateUrl: 'app/components/createProjectModal/createProjectModal.html',
                controller: CreateProjectModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function CreateProjectModalController($scope, $mdDialog, ProjectsTable) {
        cov_2ab4oeddii.f[3]++;
        cov_2ab4oeddii.s[5]++;

        $scope.newProject = ProjectsTable.$build();

        cov_2ab4oeddii.s[6]++;
        $scope.closeDialog = function () {
            cov_2ab4oeddii.f[4]++;
            cov_2ab4oeddii.s[7]++;

            $mdDialog.cancel();
        };

        cov_2ab4oeddii.s[8]++;
        $scope.createProject = function () {
            cov_2ab4oeddii.f[5]++;
            cov_2ab4oeddii.s[9]++;

            $scope.newProject.$save().$then(function (project) {
                cov_2ab4oeddii.f[6]++;
                cov_2ab4oeddii.s[10]++;

                $mdDialog.hide(project);
            });
        };
    }
})(angular);